// extracted by mini-css-extract-plugin
export var section = "bb_d";